// 导出模块
import {
  getRoster,
  saveRoster,
  joinGroup,
  getGroups
} from '@/api/request/concatService'
import store from '@/store'
import WebIM from '../utils/WebIM'
import { Message } from 'view-design'
import WebIMConfig from '../utils/WebIMConfig'
import { subscribeMsgNotice, isRefresh, singleCase, getSessionList, userInfoSessionListCompare } from '@/utils/tool'
import CommonUtil from '@/assets/js/CommonUtil'

const commonUtil = new CommonUtil()

/**
 * @author lihh
 * @description 表示环形相关的索引接口的接口
 */
class ConcatChat {

  /**
   * @author lihh
   * @description 创建用户
   * @param obj 用户id 以及昵称
   */
  _createUserJson(obj) {

    // 表示随机数 (如果想单独触发userList watch 可以设置随机数)
    const _v = commonUtil._getuuId()
    return {
      ...obj,
      subscription: 'both',
      // 表示随机数
      _v,
      jid: {
        appKey: WebIM.config.appkey,
        clientResource: 'webim_1598519637501',
        domain: WebIM.config.Host,
        name: obj.name,
        nick: obj.nick
      }
    }
  }

  /**
   * @author lihh
   * @description 表示添加用户
   * @param message 表示发送的用户信息
   */
  _addUser(message) {
    console.log('添加用户')
    // 解构数据
    const { from, data, chatType } = message
    // 设置职位id默认值
    let positionId
    // 解构 职位id
    if ( data ) [ , , , positionId = undefined ] = data.split('@@@')

    // 用来获取现有的用户
    let sessionAllUser = store.state['chat']['userList'].contactUserList || []
    // 判断发送消息的用户 是否已经存在
    for ( let i = 0; i < sessionAllUser.length; i ++ ) {
      // 判断用户是否存在
      if ( sessionAllUser[i]['name'] == from ) {
        // 列表排序
        this._settingSort(from, chatType)
      }
    }

    // 后端保存发消息的用户
    if ( from ) {

      this.saveUserInfo(from, positionId).then(res => {

        // 判断当前是否是聊天页面
        if ( !window.location.href.endsWith('home/messageManage') ) return

        // 解构数据
        const { nickName, headImg, recordId, companyPosition, positionName, isBlock } = res.data
        // 手动缓存中保存数据
        const newUser = this._createUserJson({
          nickName,
          userName: from,
          headImg,
          positionId: positionId,
          recordId,
          companyPosition,
          positionName,
          isBlock
        })

        // 获取当前用户所属的下标
        let index = - 1
        sessionAllUser.forEach((item, key) => item['name'] == from ? index = key : '')
        if ( index != - 1 ) sessionAllUser.splice(index, 1)
        // 缓存中重新设置数据
        store.dispatch('updateUserList', {
          userList: [ newUser, ...sessionAllUser ],
          type: 'contactUserList'
        })
        console.log(sessionAllUser)
        this._settingSort(from, chatType)
        // 获取当前沟通用户id
        const currentId = localStorage.getItem('currentId')
        // 用户更新职位id
        if ( index != - 1 && currentId === from ) store.dispatch('updateJob', {
          name: from,
          positionId: res.data.positionId
        })
      })
    }
  }

  /**
   * @author lihh
   * @description 设置排序  给谁发消息 谁在前面
   * @param {*} username
   * @param {*} positionId  更新职位id  没有的话 不进行更新
   */
  _settingSort(username, chatType, positionId = null) {
    const listT = chatType == 'contact' ? 'contactUserList' : 'groupUserList'
    // 获取现有的用户
    const users = store.state['chat']['userList'][listT] || []
    // 表示下标 活动用户
    let index = - 1
    let activeUser
    let isTopNum = 0
    let isTop = true

    users.forEach((item, key) => {
      if ( item.isTop == '1' ) isTopNum ++
      // 判断用户是否相等
      if ( item.name == username ) {
        if ( item.isTop == '1' ) {
          isTop = true
        } else {
          isTop = false
        }
        // 设置下标 以及用户
        index = key
        // 设置下标 以及用户
        activeUser = item
        // 判断是否有职位id
        if ( positionId ) activeUser['positionId'] = positionId
      }
    })

    // 判断是否获取到用户
    if ( index != - 1 ) {
      if ( isTop ) {
        users.splice(index, 1)
        users.unshift(activeUser)
      } else {
        users.splice(index, 1)
        users.splice(isTopNum, 0, activeUser)
      }
    }
  }

  /**
   * @author lihh
   * @description 保存用户信息
   * @param userId 表示用户id
   * @param jobId 表示职位id
   */
  async saveUserInfo(userId, jobId) {
    if ( !userId ) return false
    // 进行用户保存 之前没有用户 用户进行保存 有的话 直接返回数据
    const res = await saveRoster({ userId, jobId })
    // 判断是否请求成功
    if ( res.code != 200 ) {
      Message.error(res.msg)
      return false
    }
    return res
  }

  /**
   * @author lvcx
   * @description 保存用户信息
   * @param groupId 表示群id
   */
  async savegroupInfo(groupId) {
    if ( !groupId ) return false
    // 进行用户保存 之前没有用户 用户进行保存 有的话 直接返回数据
    const res = await joinGroup(groupId)
    // 判断是否请求成功
    if ( res.code != 200 && res.code != 20099 ) {
      Message.error(res.msg)
      return false
    }
    return res
  }

  // 获取历史记录
  // count 表示获取条数
  _getHistoryMessage(name, count = 10, isGroup) {
    let group = isGroup ? 'group' : 'contact'
    // 判断是否已经查询数据
    let msgInfo = store.state['chat']['msgList'][group][name]
    // 判断是否是数组
    if ( Array.isArray(msgInfo) ) return
    // 查询历史消息
    let params = { name, count, isGroup }
    store.dispatch('getHistoryMessage', params)
  }

  /**
   * @author lihh
   * @description 请求所有的用户 进行vuex缓存
   */
  async methodRequestBak(options = {}) {
    console.log('用来获取所有的用户')
    // 用来获取所有的用户
    let result = await getRoster(options)
    console.log(result)
    // 设置用户
    let userList = []
    // 判断是否请求成功
    if ( result.data && result.data.length > 0 ) {
      // 遍历  添加用户
      result.data.forEach(item => {
        userList.push(this._createUserJson({
          nickName: item.nickName,
          userName: item.userName,
          headImg: item.headImg,
          companyName: item.companyName,
          positionId: item.positionId, //职位id
          companyPosition: item.companyPosition, //职位名称
          recordId: item.recordId, //记录id
          positionName: item.positionName, //职位名称
          isBlock: item.isBlock //职位名称
        }))
        let isGroup = false
        this._getHistoryMessage(item.userName, 10, isGroup)
      })
    }
    // 保存vuex数据
    store.dispatch('updateUserList', {
      userList,
      type: 'contactUserList'
    })
  }

  /**
   * @author lihh
   * @description 请求所有的用户 进行vuex缓存
   */
  async methodRequestGroup(options = {}) {
    console.log('用来获取所加入的群聊')
    // 用来获取所有的用户
    let result = await getGroups(options)
    console.log(result)
    // 设置用户
    let userList = []
    // 判断是否请求成功
    if ( result.data && result.data.length > 0 ) {
      // 遍历  添加用户
      result.data.forEach(item => {
        userList.push(this._createUserJson({
          nickName: item.groupName,
          userName: item.hxGroupId,
          headImg: item.groupHeadicon,
          isTop: item.isTop
        }))
        let isGroup = true
        this._getHistoryMessage(item.hxGroupId, 10, isGroup)
      })
    }
    // 保存vuex数据
    store.dispatch('updateUserList', {
      userList,
      type: 'groupUserList'
    })
  }

  /**
   * @author lihh
   * @description 请求所有的用户 进行vuex缓存
   * @param options 表示查询的参数
   * @param flag 表示是否查询历史记录 true 查询 反之不查询
   */
  async methodRequest(options = {}, flag) {
    /* 表示沟通的所有的用户 */
    let result = await getRoster(options)
    if ( result.code !== '200' ) {
      subscribeMsgNotice('chat_singleLoading', 0)
      Message.error(result.msg)
      return
    }
    /* 判断请求结果是否为空 */
    if ( result.data.length === 0 ) {
      await store.dispatch('updateUserList', { userListStu: [], type: 'contactUserList' })
      subscribeMsgNotice('chat_singleLoading', 0)
      return
    }

    /* 获取环信的session list */
    const sessionList = await getSessionList(),
      newData = userInfoSessionListCompare(sessionList, result.data)

    // 设置用户
    const userListStu = []

    if ( typeof singleCase.__initQueryState__ == 'undefined' ) singleCase.__initQueryState__ = true
    if ( typeof singleCase.__initQueryValue__ == 'undefined' ) singleCase.__initQueryValue__ = {}

    // 遍历  添加用户
    newData.forEach(item => {
      userListStu.push(this._createUserJson({
        nick: item.nickName,
        nickName: item.nickName,
        name: item.userName,
        userName: item.userName,
        headImg: item.headImg,
        positionId: item.positionId,
        companyName: item.companyName,
        companyPosition: item.companyPosition,
        // 表示记录id(交换手机号 微信号用)
        recordId: item.recordId,
        // 表示有意向 || 不合适状态
        isInterest: item.isInterest || '0',
        // 是否第一次打招呼 isFirst
        isFirst: item.isFirst || '0',
        // 表示未读数量
        unreadNum: singleCase.__initQueryState__ ? (item.unreadNum || 0) : (singleCase.__initQueryValue__[item.userName] || 0)

      }))
    })

    /* 如果是初期查询记录数据 */
    if ( singleCase.__initQueryState__ ) userListStu.forEach(item => singleCase.__initQueryValue__[item.name] = item.unreadNum)
    /* 调整顺序 如果是从别的页面迁移过来 继续沟通的话 直接放到第一个位置 */
    const stuId = sessionStorage.getItem('stuId')
    if ( stuId ) {
      const localIndex = userListStu.findIndex(item => item.name === stuId)
      if ( localIndex !== - 1 ) {
        const target = userListStu.splice(localIndex, 1)[0]
        userListStu.unshift(target)
      }
    }
    if ( !flag ) {
      store.dispatch('updateUserList', { userListStu, type: 'contactUserList' })
      subscribeMsgNotice('chat_singleLoading', 0)
      return
    }
    /* 表示排序成功的回调方法 */
    const callback = (userInfo, flag, ids) => {
      if ( flag ) {
        store.dispatch('updateUserList', { userListStu: userInfo, type: 'contactUserList' })
      }
      (ids || []).forEach(name => {
        store.dispatch('getHistoryMessage', {
          name,
          count: 10,
          isGroup: false
        })
      })

      subscribeMsgNotice('chat_singleLoading', 0)
    }
    /* 进行排序 */
    store.commit('dataCompareOutput', {
      userInfo: userListStu,
      callback
    })
  }

  /**
   * @author lihh
   * @description 查询所有发过消息的用户
   * @param options 表示聊天界面的检索条件 (例如：打招呼，沟通中等)
   * @param flag 是否查询历史记录 false 不查询 true 查询
   */
  async _queryAllMsgUser(options = {}, flag) {
    if ( typeof flag === 'undefined' ) flag = true
    /* 判断是否刷新 */
    isRefresh(() => this.methodRequest.call(this, options, flag))
  }

  /**
   * @author lihh
   * @description 查询所有群列表（同步）
   */
  async _queryAllGroups(options = {}) {
    // 查询所有的用户
    this.methodRequestGroup.call(this, options)
  }
}

export default new ConcatChat()



// WEBPACK FOOTER //
// ./src/utils/concatChat.js